module.exports = {
  src: __webpack_public_path__ + "assets/images/check-icon.4a04462eb07d70f9.svg",
  width: 17,
  height: 15,
  toString: function() { return __webpack_public_path__ + "assets/images/check-icon.4a04462eb07d70f9.svg"; }
};